import React, { useState } from 'react';
import api from '../../services/api';
import { formatApiError } from '../../utils/errorMessage';

// "Recalculate" on an account: shows the result first (nothing saved), then
// saves on confirm. With a starting balance it recalculates from it; without
// one it adds up the account's transactions from 0. Hidden for bank-feed
// accounts without a starting balance (their balance comes from the bank).
export function canRecalculate(account) {
  if (!account) return false;
  return account.balance_source !== 'bank_feed' || Boolean(account.opening_balance_date);
}

export function recalcMessage(result, format) {
  const before = format(Number(result.previous_balance) || 0);
  const after = format(Number(result.current_balance) || 0);
  const how = result.method === 'from_transactions'
    ? 'This adds up all of this account\'s transactions, starting from $0 the day before the first one.'
    : 'This recalculates from the starting balance and every transaction after its date.';
  if (before === after) return `The balance is already right (${after}). ${how}`;
  return `Current balance will change from ${before} to ${after}. ${how} Save it?`;
}

export default function RecalculateBalanceButton({ account, format, onDone, confirm = (m) => window.confirm(m), notify = (m) => window.alert(m) }) {
  const [busy, setBusy] = useState(false);
  if (!canRecalculate(account)) return null;
  const run = async () => {
    setBusy(true);
    try {
      const url = `/accounts/${account.id}/recalculate-balance`;
      const preview = (await api.post(`${url}?preview=1`)).data;
      const message = recalcMessage(preview, format);
      if (Number(preview.previous_balance) === Number(preview.current_balance)) { notify(message); return; }
      if (!confirm(message)) return;
      await api.post(url);
      if (onDone) onDone();
    } catch (err) {
      notify(formatApiError(err, 'Could not recalculate the balance'));
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" onClick={run} disabled={busy} className="text-gray-700 hover:text-gray-900 mr-3"
      title="Recalculate the current balance from this account's transactions">
      {busy ? 'Checking...' : 'Recalculate'}
    </button>
  );
}
